$(document).ready(function() {
    if (typeof window.AffiliateStaffGrid !== 'undefined') {
        $('#affiliate-staff-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                {
                    field: 'FirstName',
                    title: 'First Name'
                },
                {
                    field: 'Surname',
                    title: 'Surname'
                },
                {
                    field: 'AffiliateParentTitle',
                    title: 'Affiliate'
                },
                {
                    filterable: false,
                    title: '',
                    width: '250px',
                    template:
                        ' <a href="/affiliate/editdetails/${ID}" id="edit-details-${ ID }" data-record-id="${ ID }" class="btn small primary edit-btn">Edit</a>'
                }
            ],
            dataSource: window.AffiliateStaffGrid
        });
    }
});
